<template>
  <el-table :data="data" v-loading="loading" border class="data-table">
    <el-table-column :label="$t('SpecialAccountManagement.serialNumber')" width="80" align="center">
      <template #default="scope">
        {{ scope.row.id }}
      </template>
    </el-table-column>
    <el-table-column :label="$t('SpecialAccountManagement.userAccount')" min-width="150" align="center" show-overflow-tooltip>
      <template #default="scope">
        {{ scope.row.user && scope.row.user.email ? scope.row.user.email : scope.row.userId }}
      </template>
    </el-table-column>
    <el-table-column :label="$t('SpecialAccountManagement.beginAt')" width="180">
      <template #default="scope">
        <span>{{ formatDate(scope.row.beginAt) }}</span>
      </template>
    </el-table-column>
    <el-table-column :label="$t('SpecialAccountManagement.endAt')" width="180">
      <template #default="scope">
        <span>{{ formatDate(scope.row.endAt) }}</span>
      </template>
    </el-table-column>
    <el-table-column :label="$t('SpecialAccountManagement.enableStatus')" width="100" align="center">
      <template #default="scope">
        <el-tag :type="scope.row.enable ? 'success' : 'danger'" size="small">
          {{ scope.row.enable ? $t('SpecialAccountManagement.enable') : $t('SpecialAccountManagement.disable') }}
        </el-tag>
      </template>
    </el-table-column>
    <el-table-column :label="$t('SpecialAccountManagement.createdUserEmail')" min-width="150" align="center" show-overflow-tooltip>
      <template #default="scope">
        {{ scope.row.createdUser && scope.row.createdUser.email ? scope.row.createdUser.email : scope.row.createdBy }}
      </template>
    </el-table-column>
    <el-table-column :label="$t('SpecialAccountManagement.createdAt')" width="180">
      <template #default="scope">
        <span>{{ formatDate(scope.row.createdAt) }}</span>
      </template>
    </el-table-column>
    <el-table-column :label="$t('SpecialAccountManagement.updatedAt')" width="180">
      <template #default="scope">
        <span>{{ formatDate(scope.row.updatedAt) }}</span>
      </template>
    </el-table-column>
    <el-table-column :label="$t('SpecialAccountManagement.action')" width="180" fixed="right" align="center">
      <template #default="scope">
        <el-button type="primary" size="small" @click="handleEdit(scope.row)">
          {{ $t('SpecialAccountManagement.edit') }}
        </el-button>
        <el-button
          :type="scope.row.enable ? 'warning' : 'success'"
          size="small"
          @click="handleEnable(scope.row.id, !scope.row.enable)"
        >
          {{ scope.row.enable ? $t('SpecialAccountManagement.disable') : $t('SpecialAccountManagement.enable') }}
        </el-button>
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
export default {
  props: {
    data: {
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    // 格式化日期时间
    formatDate(dateString) {
      if (!dateString) return '';
      const date = new Date(dateString);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      const seconds = String(date.getSeconds()).padStart(2, '0');
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },
    // 处理编辑
    handleEdit(row) {
      this.$emit('edit', row);
    },
    // 处理启用/禁用
    handleEnable(id, enable) {
      this.$emit('enable', id, enable);
    }
  }
};
</script>

<style scoped>
.data-table {
  margin-top: 10px;
}
</style>